import { mapState } from 'vuex';
export default {
  name: 'MediaUpload',
  props: {
    type: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    buttonIcon: {
      type: String,
      default: ''
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      url: null,
      file: null,
      turn: 0,
      responsive: false,
      responsiveInput: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    rotate() {
      this.$emit('rotateImage', this.turn);
      return {
        transform: `rotate(${this.turn}turn)`
      };
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener('resize', this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResponsiveInverted);
  },
  methods: {
    handleFileUpload(event) {
      var input = event.target;
      if (input.files && input.files[0]) {
        this.file = input.files[0];
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.url = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
        // new image; reset rotation to zero
        this.turn = 0;
        this.$emit('rotateImage', this.turn);
        // send file to parent component
        this.$emit('getFile', this.file);
      }
    },
    clear() {
      const input = this.$refs.file;
      input.type = 'text';
      input.type = 'file';
      this.file = null;
      this.url = null;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    },
    onUploadBtnClick() {
      // eslint-disable-next-line no-empty-function
      window.addEventListener('focus', () => {}, {
        once: true
      });
      this.$refs.file.click();
    }
  }
};